import React, { useEffect, useState } from "react";
import { EditForm } from "../components";
import { UploadFileComp } from "../components/layout";
import { useGetProfileQuery, useUpdateProfileMutation } from "../store";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";

export default function EditUserModel(props) {
  const { data } = useGetProfileQuery();
  const [updateProfile, { error, isLoading, isSuccess }] =
    useUpdateProfileMutation();

  const userAttr = [
    {
      type: "text",
      props: {
        label: "Name",
        name: "name",
        required: true,
      },
    },
  ];

  const [file, setFile] = useState(null);
  const [value, setValue] = useState(null);
  const [info, setInfo] = useState({
    name: null,
    phone: null,
    country_code: null,
  });

  console.log(file);
  useEffect(() => {
    if (data?.user) {
      setInfo({
        name: data.user.name,
        phone_no: data.user.phone,
        country_code: data.user.country_code,
      });
      setValue(data.user.country_code + data.user.phone);
      setFile(data.user.image);
    }
  }, [data?.user]);

  const submitHandler = async (e) => {
    e.preventDefault();
    const data = {
      avatar: file,
      name: info.name,
      phone_no: info.phone,
      country_code: info.country_code,
    };
    console.log("....data", data);
    updateProfile(data);
  };
  console.log("........error", error);
  return (
    <EditForm
      {...props}
      title="Update Profile"
      data={info}
      setData={setInfo}
      inputFieldProps={userAttr}
      submitHandler={submitHandler}
      // target="/admin/view-profile"
      successMessage="Profile Updated Successfully! Redirecting..."
      reducerProps={{ loadingUpdate: isLoading, error, success: isSuccess }}
    >
      <div>
        <div>
          <p style={{ marginBottom: "0.5rem" }}>Mobile No.</p>
          <PhoneInput
            className="form-control mb-3 "
            placeholder="Enter phone number"
            value={value}
            onChange={(e) => {
              if (e) {
                const countryCode = parsePhoneNumber(e)?.countryCallingCode;
                const mobileNum = parsePhoneNumber(e)?.nationalNumber;
                setInfo({
                  ...info,
                  country_code: "+" + countryCode,
                  phone_no: mobileNum,
                });
                setValue("+" + countryCode + mobileNum);
              }
            }}
          />
        </div>
        <div>
          <UploadFileComp
            label="Profile Image"
            fileType={"image"}
            accept="image/*"
            file={file}
            setFile={setFile}
          />
          <img src={file} width={60} height={60} className="m-2" />
        </div>
      </div>
    </EditForm>
  );
}
